import type { AlertServiceAnalyticsEvent } from '@/scopes/prices/domain/analytics'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { useAccommodationContext } from '@/scopes/prices/components/AccommodationContext'
import { useMutation } from '@tanstack/react-query'
import defaultFetch from 'isomorphic-unfetch'

export function useAlertService() {
  const { contextItemId, alertServiceDataSourceId } = useAccommodationContext()
  const { sendEvent } = useAnalytics()

  const {
    mutate,
    isPending: isLoading,
    isError,
    isSuccess,
    reset,
    data,
  } = useMutation({
    mutationFn: async (email: string) => {
      const response = await defaultFetch(
        `${process.env.NEXT_PUBLIC_API_BASE_URL}/PriceAlert/CreateAlertSubscription?contextitemid=${contextItemId}`,
        {
          method: 'POST',
          body: JSON.stringify({
            datasourceId: alertServiceDataSourceId,
            email,
            itemId: contextItemId,
          }),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        },
      )
      if (!response.ok) {
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject()
      }
      return response.json()
    },
    onSuccess: () => {
      sendEvent({
        event: 'Next Season Alert',
        description: 'Alert Service',
        type: 'Next Season',
        result: 'Signup',
        eventValue: 1,
      } as AlertServiceAnalyticsEvent)
    },
  })

  return {
    mutate,
    isLoading,
    isError,
    isSuccess,
    reset,
    data,
  }
}
